export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "web-worker.8df1f16cc0c1587decdd.js");
}
